import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import styles from './JobTest.module.scss'

const JobTest = ({ link, target, image = 'job-test-banner.png' }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpeg)|(png)/" } }) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)

  const imageMap = {}
  data?.allFile?.edges?.forEach((img) => {
    imageMap[img.node.base] = img.node.childImageSharp.gatsbyImageData
  })

  return (
    <div className={`${styles.main}`}>
      <div className="container-fluid text-center pb-5">
        <a
          rel="nofollow noreferrer"
          target={target || '_self'}
          className=""
          href={link}
        >
          <GatsbyImage
            loading="lazy"
            alt="Job Test Prep"
            image={getImage(imageMap[image])}
          />
        </a>
      </div>
    </div>
  )
}

export default JobTest
// jobtestprepmobile.jpeg
